var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.8125,
    fill: "#FCFCFC",
    stroke: "#2787E4",
    strokeWidth: 1.375
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9451 14.4031L17.4626 18.8856C16.9332 19.415 16.0669 19.415 15.5376 18.8856L11.0551 14.4031",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9451 14.4031L17.4626 18.8856C16.9332 19.415 16.0669 19.415 15.5376 18.8856L11.0551 14.4031",
    stroke: "#2787E4",
    strokeWidth: 2.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/iconClose.1c480ce7b54a80c160413169d45a8dec.svg";
export { ForwardRef as ReactComponent };